import React, {
  Fragment,
  useCallback,
  useState,
  useEffect,
  useRef,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FacetedSearchCompact from './FacetedSearchCompact';
import { query } from '../Actions/FacetedSearch.action';
import { updateFilterOption } from '../Actions/FacetedSearch.action';
import { PRODUCT_VIEW_CACHED } from '../constants';

const FacetedSearchCompactContainer = () => {
  const dispatch = useDispatch();
  const {
    subNavigation,
    sortCriteria,
    facetFilters: globalFacetFilters,
    navigationTheme,
    productsViewCachedId,
  } = useSelector((state) => state.facetedSearch);

  const [facetFilters, setFacetFilters] = useState(globalFacetFilters || []);
  const previousCachedId = useRef(productsViewCachedId);
  useEffect(() => {
    if (previousCachedId.current !== productsViewCachedId) {
      setFacetFilters(globalFacetFilters);
      previousCachedId.current = productsViewCachedId;
    }
  }, [globalFacetFilters, productsViewCachedId]);

  useEffect(() => {
    dispatch(query(window.location.search.substr(1) || '', false));
  }, [dispatch]);

  const onFacetChange = useCallback(
    (filter, option) => {
      setFacetFilters((prevFacetFilters) => {
        return updateFilterOption(prevFacetFilters, filter, option);
      });
    },
    [setFacetFilters]
  );

  useEffect(() => {
    const productViewCached = window.__litium.cache
      ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {}
      : {};
    if (!productViewCached.used) {
      productViewCached.used = true;
      const dom = productViewCached.productsView;
      dom && onSearchResultDataChange(dom);
    }
  });

  const empty = (array) => !(array && array.length);

  const subNavigations = !subNavigation ? null : [subNavigation];
  const sortCriterias =
    !sortCriteria || !sortCriteria.sortItems ? null : sortCriteria.sortItems;

  const hidden = [subNavigations, facetFilters, sortCriterias].every((arr) =>
    empty(arr)
  );

  return hidden ? null : (
    <Fragment>
      {navigationTheme === 'category' && (
        <div className="compact-filter category-theme show-for-large">
          <FacetedSearchCompact
            {...{
              facetFilters,
              onFacetChange,
            }}
          />
        </div>
      )}
    </Fragment>
  );
};

export default FacetedSearchCompactContainer;
